import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { CIRCLE_COMMUNITY_WHATS_NEW_URL } from "../constants";
import { useListNews } from "../hooks/useListNews";
import type { Post } from "../types/post";
import { NewsPost } from "./NewsPost";
import { SkeletonLoader } from "./common/SkeletonLoader";

export const NewsListView = () => {
  const { isLoading, data } = useListNews();

  if (isLoading) {
    return (
      <>
        <SkeletonLoader rows={1} height="52px" wrapperClassName="!px-0 mb-4" />
        <SkeletonLoader rows={2} height="170px" wrapperClassName="px-2 mb-4" />
      </>
    );
  }

  const posts = data?.records || [];

  return (
    <div className="scrollbar-hide bg-secondary flex flex-col overflow-auto py-4">
      <div className="px-4">
        {posts.map((post: Post) => (
          <NewsPost key={post.id} post={post} />
        ))}
        <a
          href={CIRCLE_COMMUNITY_WHATS_NEW_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="see-more-news border-disabled flex h-8 items-center justify-center gap-1 self-stretch rounded-3xl border px-4"
        >
          <Typography.LabelSm color="text-primary" weight="medium">
            {t("support_widget.news.see_more")}
          </Typography.LabelSm>
          <Icon type="sw-popout" useWithFillCurrentColor size={16} />
        </a>
      </div>
    </div>
  );
};
